module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    staticClass: "gencode"
  }, [_c('div', {
    staticClass: "gencode-select"
  }, [_c('domain-select', {
    attrs: {
      "extra": "为网站$domain添加监测代码"
    },
    on: {
      "change": _vm.onDomainChange
    }
  }), _c('div', {
    staticClass: "code-type-select"
  }, [_c('span', [_vm._v("选择代码类型：")]), _vm._l((_vm.codeTypes), function(option) {
    return [_c('label', {
      staticClass: "type-label",
      on: {
        "change": function($event) {
          _vm.changeCodeType(option.value)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentCodeType),
        expression: "currentCodeType"
      }],
      attrs: {
        "type": "radio",
        "name": "codeType"
      },
      domProps: {
        "value": option.value,
        "checked": _vm.currentCodeType === option.value,
        "checked": _vm._q(_vm.currentCodeType, option.value)
      },
      on: {
        "click": function($event) {
          _vm.currentCodeType = option.value
        }
      }
    }), _c('i'), _c('span', [_vm._v(_vm._s(option.title))]), (!_vm.isBaseMode && _vm.currentCodeType === option.value) ? _c('div', {
      staticClass: "code-tip"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v("获取" + _vm._s(_vm.currentCodeTypeDesc) + "，需要先安装基础流量代码。")]) : _vm._e()])]
  }), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domainSource != 'mv'),
      expression: "domainSource != 'mv'"
    }],
    staticClass: "btn btn-primary btn-big get-code-text",
    attrs: {
      "target": "_blank",
      "href": '/dist/text.html?dmid=' + _vm.domainId
    }
  }, [_vm._v(" 获取说明文档")])], 2)], 1), _c('div', [_vm._m(0), _c('div', {
    staticClass: "code"
  }, [_c('pre', {
    ref: "jsCodeDOM",
    attrs: {
      "id": "gencode-pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentJSCodeEscaped)
    }
  })]), (!_vm.isBaseMode) ? _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v(" ②")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("代码配置")]), _c('span', {
    staticClass: "gen-des",
    domProps: {
      "innerHTML": _vm._s(_vm.codeConfTip)
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentCodeType != 'register'),
      expression: "currentCodeType != 'register'"
    }],
    staticClass: "gen-action",
    on: {
      "click": _vm.showConfModal
    }
  }, [_vm._v(" 查看配置变量")])]) : _vm._e(), _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v(" " + _vm._s(_vm.isBaseMode ? '②' : '③'))]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("代码安装")]), _c('span', {
    staticClass: "gen-des"
  }, [_vm._v("请将框内代码复制到您网站"), _c('em', [_vm._v(_vm._s(_vm.installPageName))]), _vm._v("的</body>前，添加成功后立即开始统计。")])]), (_vm.isBaseMode) ? _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v(" ③")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("代码检查")]), _c('span', {
    staticClass: "gen-des"
  }, [_vm._v("代码配置成功后，点击代码检查查看是否是否安装成功。")]), _c('span', {
    staticClass: "gen-action curptr",
    on: {
      "click": _vm.goToCheck
    }
  }, [_vm._v("代码检查")])]) : _vm._e(), _vm._m(1), _c('div', {
    staticClass: "note-text"
  }, [_vm._v("（注：加载360统计代码不会影响您网页的正常显示和加载速度，请放心添加。）")])])]), _c('div', {
    on: {
      "click": _vm.interceptMaskClick
    }
  }, [(!_vm.isBaseMode) ? _c('v-modal', {
    attrs: {
      "visible": _vm.shouldShowModal,
      "title": "查看配置变量（变量可以根据您的要求进行配置）"
    },
    on: {
      "closemodal": _vm.shutConfModal
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("字段")]), _c('th', [_vm._v("说明")])])]), _c('tbody', _vm._l((_vm.varConfig), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item[0]))]), _c('td', [_vm._v(_vm._s(item[1]))])])
  }))])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v(" ①")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("获取初始代码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v("④")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("安装完成")]), _c('span', {
    staticClass: "gen-des"
  }, [_vm._v("代码安装成功后第二天可以查看数据。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c20d0e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c20d0e6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/gencode_get.vue
// module id = 758
// module chunks = 0